import React from 'react';
import { Link } from 'react-router-dom';
import './OpinionSection.css';

const OpinionSection = () => {
  const opinions = [
    {
      author: 'Mihir Sharma',
      title: 'Why US Tariffs Failed to Dent Global Trade',
      image: 'https://images.unsplash.com/photo-1507679799987-c73779587ccf?w=80&h=80&fit=crop',
      // slug: '/opinion/us-tariffs-global-trade'
      slug: "/article/us-futures-bank-earnings"
    },
    {
      author: 'Andy Mukherjee',
      title: 'Five Questions About Money to Ponder in 2026',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop',
      // slug: '/opinion/money-questions-2026'
       slug: "/article/fed-hq-renovation-cost"

    },
    {
      author: 'Matt Levine',
      title: 'Everybody Wants Some AI Debt',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop',
      // slug: '/opinion/ai-debt'
      slug: "/article/ai-revolution-transforms-industries"
    },
  ];

  return (
    <section className="content-section">
      <div className="section-header-inline">
        <h2>RedboxGlobal Opinion</h2>
      </div>

      <Link to="/opinion/world-split-china" className="opinion-featured-link">
        <div className="opinion-featured">
          <div className="opinion-featured-image">
            <img 
              src="https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?w=400&h=250&fit=crop" 
              alt="Venezuela protest"
            />
          </div>
          <div className="opinion-featured-content">
            <h2>A World Split in Two Is Just What China Wants</h2>
            <p className="author-byline">By Karishma Vaswani, Columnist</p>
          </div>
        </div>
      </Link>

      <div className="opinion-grid-secondary">
        {opinions.map((opinion, index) => (
          <Link 
            to={opinion.slug}
            key={index} 
            className="opinion-card-link"
          >
            <article className="opinion-item">
              <div className="opinion-item-inner">
                <img src={opinion.image} alt={opinion.author} className="author-avatar" />
                <div className="opinion-text">
                  <h3>{opinion.title}</h3>
                  <p className="author-byline">By {opinion.author}, Columnist</p>
                </div>
              </div>
            </article>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default OpinionSection;





